import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { putCoreSonarObjectsStakeholdersBulkSlice } from './put';

export const coreSonarObjectsStakeholdersBulkReducers = combineReducers({
	put: putCoreSonarObjectsStakeholdersBulkSlice.asyncReducers
});

export const coreSonarObjectsStakeholdersBulkWatchers = combineAllWatchers([
	putCoreSonarObjectsStakeholdersBulkSlice.asyncWatchers
]);
